import { useDialogStore } from './dialog-store';
import { DialogType, ModalDialogType } from './dialog-types';
import { delay } from 'lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useDialog() {
  const dialogStore = useDialogStore();

  const getIsActive = (): boolean => {
    return dialogStore.isActive;
  };

  const getTitle = (): string | null => {
    return dialogStore.title;
  };

  const getMessage = (): string | null => {
    return dialogStore.message;
  };

  const getType = (): ModalDialogType | null => {
    return dialogStore.type;
  };

  const setIsActive = (state: boolean): void => {
    dialogStore.setIsActive(state);
  };

  const setTitle = (title: string | null): void => {
    dialogStore.setTitle(title);
  };

  const setMessage = (message: string | null): void => {
    dialogStore.setMessage(message);
  };

  const setType = (type: ModalDialogType | null): void => {
    dialogStore.setType(type);
  };

  const openDialog = (
    type: ModalDialogType,
    message: string,
    title: string | null = null,
    yesCallback: any = null
  ): void => {
    setType(type);
    setMessage(message);

    if (title === null) {
      switch (type) {
        case DialogType.SUCCESS:
          setTitle('Success!');
          break;
        case DialogType.WARNING:
          setTitle('Warning!');
          break;
        case DialogType.ERROR:
          setTitle('Error!');
          break;
        case DialogType.INFO:
          setTitle('Info');
          break;
        case DialogType.CONFIRM:
          setTitle('Confirm');
          break;
      }
    } else {
      setTitle(title);
    }

    setIsActive(true);

    delay(() => {
      const btnYes = document.getElementById('btnModalDialogYes');
      const btnNo = document.getElementById('btnModalDialogNo');

      if (btnYes) {
        btnYes.addEventListener('click', () => {
          yesCallback();
        });
      }

      if (btnNo) {
        btnNo.addEventListener('click', () => {
          closeDialog();
        });
      }
    }, 10);
  };

  const closeDialog = (): void => {
    setIsActive(false);

    // Becoz of css transition
    delay(() => {
      setTitle(null);
      setMessage(null);
      setType(null);
    }, 300);
  };

  return {
    getIsActive,
    getTitle,
    getMessage,
    getType,
    openDialog,
    closeDialog,
  };
}
